<template>
  <div class="page">
    <div class="nucleus">
      <div class="nucleustit">
        <div class="suntit">
          {{ curStaffMsg.staffName }}-----
          <span class="position">({{ curStaffMsg.position }})</span>
        </div>
        <div style="margin-top: 2px">
          <el-select
          :disabled="!$buttonAuthority('shuju-staffshuju-staff')"
            filterable
            style="width: 150px"
            v-model="curStaffMsg"
            value-key="staffId"
            placeholder="请选择员工"
            size="mini"
            @change="changeStaff"
          >
            <el-option
              v-for="item in staffList"
              :key="item.staffId"
              :label="item.staffName"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-model="curDate"
            type="month"
            placeholder="请选择月份"
            size="mini"
            style="width: 150px; margin-left: 10px"
            :picker-options="{
              disabledDate(date) {
                return (
                  date.getTime() > Date.now() ||
                  date.getTime() < new Date('2021-08-01').getTime()
                );
              },
            }"
            @change="changePicker"
            :clearable="false"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="nucleuscon">
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">当月 提成金额</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.royaltyMoney.current"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
            </div>
           </div>
        </div>
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">当月 业绩</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.saleMoney.current"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
               </div>
           </div>
        </div>
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">当月 充值订单金额</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.rechargeMoney.current"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
            </div>
           </div>
        </div>
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">当月 服务人次</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.servicePeopleCount.current"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
            </div>
       </div>
        </div>
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">当月 订单数</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.orderCount.current"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
            </div>
         </div>
        </div>
        <div class="nucleusitem">
          <div class="content">
            <div class="currentit">总退款金额</div>
            <div class="data">
              <span v-if="!state1">0</span>
              <animate-number
                v-else
                from="0"
                :to="datas.returnMoney.all"
                :formatter="
                  (num) => {
                    return num.toFixed(2);
                  }
                "
              ></animate-number>
              <el-tooltip v-if="state1" effect="dark" placement="top-start">
                <div slot="content" style="line-height: 20px">
                  当月退款：{{ datas.returnMoney.new }}<br />
                  往月退款：{{ datas.returnMoney.old }}<br />
                </div>
                <img
                  src="../../assets/img/icon_eye.jpg"
                  style="width: 20px; margin-left: 0px; vertical-align: middle"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="saledatacontent">
      <div class="L">
        <div class="mapBox" style="height: 347px">
          <div class="mapTitle">业绩销售依据状图</div>
          <div class="mapContent" id="map1" style="height: 309px"></div>
        </div>
        <div class="mapBox" style="height: 281px; margin-top: 10px">
          <div class="mapTitle">提成依据状图</div>
          <div class="mapContent" id="map2" style="height: 243px"></div>
        </div>
      </div>
      <div class="R">
        <div class="rulesLine">
          <div class="money">
            提成金额：<span
              style="font-size: 18px; color: #333; font-weight: bold"
              >{{
                datas.staffStaticModel.royaltyMoney &&
                datas.staffStaticModel.royaltyMoney.money
              }}</span
            >
          </div>
          <!-- <div class="rules" @click="seeRules">查看提成规则 > </div> -->
        </div>
        <div class="scoll" v-if="datas.staffStaticModel.royaltyMoney">
          <!-- 现金流水 -->
          <div
            class="tabBox"
            v-if="
              [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
            "
          >
            <div class="tabTit">
              <div class="colTit">
                现金流水
                <span
                  v-if="
                    datas.staffStaticModel.saleStaffStatic.nodeMoney.money > 0
                  "
                >
                  <span
                    v-if="
                      datas.staffStaticModel.saleStaffStatic.nodeMoney.money >
                      datas.staffStaticModel.saleStaffStatic
                        .indicatorPerformance.money
                    "
                  >
                    &lt;
                    {{ datas.staffStaticModel.saleStaffStatic.nodeMoney.money }}
                  </span>
                  <span v-else>
                    ≥
                    {{ datas.staffStaticModel.saleStaffStatic.nodeMoney.money }}
                  </span>
                </span>
                <span v-else>
                  ≥
                  {{
                    datas.staffStaticModel.saleStaffStatic.nodeMinMoney.money
                  }}
                </span>
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.saleStaffStatic,
                    'saleStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  当月业绩小于3万，提成5%<br />当月业绩大于等于3万小于5万，提成7%<br />当月业绩大于等于5万，提成10%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">商品</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.saleStaffStatic.goodsPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.saleStaffStatic.goodsPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">医疗</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.saleStaffStatic.medicalPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.saleStaffStatic.medicalPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">活体</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.saleStaffStatic.huoTiPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.saleStaffStatic.huoTiPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[0].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.saleStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[0].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 洗美提成 -->
          <div
            class="tabBox"
            v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
          >
            <div class="tabTit">
              <div class="colTit">
                洗澡提成
                <span
                  v-if="
                    datas.staffStaticModel.xiMeiStaffStatic.nodeMoney.money > 0
                  "
                >
                  <span
                    v-if="
                      datas.staffStaticModel.xiMeiStaffStatic.nodeMoney.money >
                      datas.staffStaticModel.xiMeiStaffStatic
                        .indicatorPerformance.money
                    "
                  >
                    &lt;
                    {{
                      datas.staffStaticModel.xiMeiStaffStatic.nodeMoney.money
                    }}
                  </span>
                  <span v-else>
                    ≥
                    {{
                      datas.staffStaticModel.xiMeiStaffStatic.nodeMoney.money
                    }}
                  </span>
                </span>
                <span v-else>
                  ≥
                  {{
                    datas.staffStaticModel.xiMeiStaffStatic.nodeMinMoney.money
                  }}
                </span>
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.xiMeiStaffStatic,
                    'xiMeiStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  小于等于5000元时，提成点20%<br />大于5000小于等于10000元时，提成点25%<br />大于10000元时，提成点30%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">洗澡</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.xiMeiStaffStatic.xiMeiSalePerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.xiMeiStaffStatic.xiMeiSalePerformance
                      .realPerformance.money,
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">洗澡美团</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.xiMeiStaffStatic.meiTuanPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.xiMeiStaffStatic.meiTuanPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">洗澡卡核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.xiMeiStaffStatic
                    .consumerCardCancelPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.xiMeiStaffStatic
                      .consumerCardCancelPerformance.realPerformance.money,
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[1].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.xiMeiStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[1].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 美容提成 -->
          <div
            class="tabBox"
            v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
          >
            <div class="tabTit">
              <div class="colTit">
                美容提成
                <span
                  v-if="
                    datas.staffStaticModel.meiRongStaffStatic.nodeMoney.money >
                    0
                  "
                >
                  <span
                    v-if="
                      datas.staffStaticModel.meiRongStaffStatic.nodeMoney
                        .money >
                      datas.staffStaticModel.meiRongStaffStatic
                        .indicatorPerformance.money
                    "
                  >
                    &lt;
                    {{
                      datas.staffStaticModel.meiRongStaffStatic.nodeMoney.money
                    }}
                  </span>
                  <span v-else>
                    ≥
                    {{
                      datas.staffStaticModel.meiRongStaffStatic.nodeMoney.money
                    }}
                  </span>
                </span>
                <span v-else>
                  ≥
                  {{
                    datas.staffStaticModel.meiRongStaffStatic.nodeMinMoney.money
                  }}
                </span>
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.meiRongStaffStatic,
                    'meiRongStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  业绩小于等于5000元时 提成点30%<br />大于5000小于等于10000元时，提成点35%<br />大于10000元时，提成点40%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">美容</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.meiRongStaffStatic
                    .meiRongSalePerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.meiRongStaffStatic
                      .meiRongSalePerformance.realPerformance.money,
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">美容美团</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.meiRongStaffStatic
                    .meiRongMeiTuanPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.meiRongStaffStatic
                      .meiRongMeiTuanPerformance.realPerformance.money,
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[3, 4].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">美容卡核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.meiRongStaffStatic
                    .meiRongConsumerCardCancelPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.meiRongStaffStatic
                      .meiRongConsumerCardCancelPerformance.realPerformance
                      .money,
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[2].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.meiRongStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[2].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 充值业绩 -->
          <div
            class="tabBox"
            v-if="
              [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
            "
          >
            <div class="tabTit">
              <div class="colTit">
                充值业绩
                <span
                  v-if="
                    datas.staffStaticModel.rechargeStaffStatic.nodeMoney.money >
                    0
                  "
                >
                  <span
                    v-if="
                      datas.staffStaticModel.rechargeStaffStatic.nodeMoney
                        .money >
                      datas.staffStaticModel.rechargeStaffStatic
                        .indicatorPerformance.money
                    "
                  >
                    &lt;
                    {{
                      datas.staffStaticModel.rechargeStaffStatic.nodeMoney.money
                    }}
                  </span>
                  <span v-else>
                    ≥
                    {{
                      datas.staffStaticModel.rechargeStaffStatic.nodeMoney.money
                    }}
                  </span>
                </span>
                <span v-else>
                  ≥
                  {{
                    datas.staffStaticModel.rechargeStaffStatic.nodeMinMoney
                      .money
                  }}
                </span>
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.rechargeStaffStatic,
                    'rechargeStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content" v-if="flag==true">
               当月业绩3万以下，提成5%<br />当月业绩大于等于3万小于5万，提成7%<br />当月业绩大于等于5万，提成10% 
                </div>
                <div slot="content" v-if="flag==false">
                  当月业绩1.5万以下，提成5%<br />当月业绩大于等于1.5万小于3万，提成7%<br />当月业绩大于等于3万，提成10%
              
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">充值</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.rechargeStaffStatic.rechargePerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.rechargeStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.rechargeStaffStatic
                      .rechargePerformance.realPerformance.money,
                    datas.staffStaticModel.rechargeStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[3].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.rechargeStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[3].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 综合提成 -->
          <div
            class="tabBox"
            v-if="
              [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
            "
          >
            <div class="tabTit">
              <div class="colTit">
                综合提成
                <!-- <span v-if="datas.staffStaticModel.virtualStaffStatic.nodeMoney.money>0">
									<span v-if="datas.staffStaticModel.virtualStaffStatic.nodeMoney.money>datas.staffStaticModel.virtualStaffStatic.indicatorPerformance.money">
										&lt; {{datas.staffStaticModel.virtualStaffStatic.nodeMoney.money}}
									</span>
									<span v-else>
										≥ {{datas.staffStaticModel.virtualStaffStatic.nodeMoney.money}}
									</span>
								</span>
								<span v-else>
									> {{datas.staffStaticModel.virtualStaffStatic.nodeMinMoney.money}}
								</span> -->
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.virtualStaffStatic,
                    'virtualStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content" v-if="flag==true">
                  <!-- 套餐和洗澡卡单笔提成点数为5%，不计入当月业绩 -->
                  洗澡卡和套餐卡小于5000 提成3%，大于等于5000，提成5%
                </div>
                <div slot="content" v-if="flag==false">
                  套餐和洗澡卡单笔提成点数为5%，不计入当月业绩 
                <!-- 余额和套餐卡小于1万 提成3%，大于等于1万，提成5%，  -->
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">消费卡销售</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.virtualStaffStatic.consumerCard
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.virtualStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.virtualStaffStatic.consumerCard
                      .realPerformance.money,
                    datas.staffStaticModel.virtualStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">套餐销售</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.virtualStaffStatic
                    .medicalPackageServicePerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.virtualStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.virtualStaffStatic
                      .medicalPackageServicePerformance.realPerformance.money,
                    datas.staffStaticModel.virtualStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[4].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.virtualStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[4].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 寄养提成 -->
          <div
            class="tabBox"
            v-if="
              [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
            "
          >
            <div class="tabTit">
              <div class="colTit">
                寄养提成
                <!-- <span v-if="datas.staffStaticModel.jiYangStaffStatic.nodeMoney.money>0">
									<span v-if="datas.staffStaticModel.jiYangStaffStatic.nodeMoney.money>datas.staffStaticModel.jiYangStaffStatic.indicatorPerformance.money">
										&lt; {{datas.staffStaticModel.jiYangStaffStatic.nodeMoney.money}}
									</span>
									<span v-else>
										≥ {{datas.staffStaticModel.jiYangStaffStatic.nodeMoney.money}}
									</span>
								</span>
								<span v-else>
									> {{datas.staffStaticModel.jiYangStaffStatic.nodeMinMoney.money}}
								</span> -->
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.jiYangStaffStatic,
                    'jiYangStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  销售人员当月所服务寄养业务实收金额的15%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">寄养</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.jiYangStaffStatic.jiYangPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.jiYangStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.jiYangStaffStatic.jiYangPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.jiYangStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[5].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.jiYangStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[5].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 跟诊提成 -->
          <div
            class="tabBox"
            v-if="[2].indexOf(datas.staffStaticModel.staffType) > -1"
          >
            <div class="tabTit">
              <div class="colTit">
                跟诊提成
                <span
                  v-if="
                    datas.staffStaticModel.followStaffStatic.nodeMoney.money > 0
                  "
                >
                  <span
                    v-if="
                      datas.staffStaticModel.followStaffStatic.nodeMoney.money >
                      datas.staffStaticModel.followStaffStatic
                        .indicatorPerformance.money
                    "
                  >
                    &lt;
                    {{
                      datas.staffStaticModel.followStaffStatic.nodeMoney.money
                    }}
                  </span>
                  <span v-else>
                    ≥
                    {{
                      datas.staffStaticModel.followStaffStatic.nodeMoney.money
                    }}
                  </span>
                </span>
                <span v-else>
                  >
                  {{
                    datas.staffStaticModel.followStaffStatic.nodeMinMoney.money
                  }}
                </span>
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.followStaffStatic,
                    'followStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content">
                  当月跟诊业绩1.5万元以下提成点数为1%<br />月跟诊业绩在1.5万元及以上提成点数为2%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="[2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">医疗</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.followStaffStatic.followPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.followStaffStatic.followPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">疫苗驱虫</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.followStaffStatic.medicalPackageRoyalty
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.followStaffStatic
                      .medicalPackageRoyalty.realPerformance.money,
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">医疗服务</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.followStaffStatic.medicalServiceRoyalty
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.followStaffStatic
                      .medicalServiceRoyalty.realPerformance.money,
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[6].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.followStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[6].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 其它金额 -->
          <div
            class="tabBox"
          >
            <div class="tabTit">
              <div class="colTit">
                其它金额
             </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.subsidyStaffStatic,
                    'subsidyStaffStatic'
                  )
                "
              >
                查看
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1, 2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">夜诊</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.subsidyStaffStatic.yeZhenPerformance
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.subsidyStaffStatic.yeZhenPerformance
                      .realPerformance.money,
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1, 2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">夜诊护理</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.subsidyStaffStatic
                    .yeZhenHuLiPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.subsidyStaffStatic
                      .yeZhenHuLiPerformance.realPerformance.money,
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem">刷牙补助</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.subsidyStaffStatic.shuaYa
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.subsidyStaffStatic.shuaYa
                      .realPerformance.money,
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1, 2].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">DR补助</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.subsidyStaffStatic.subsidy
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.subsidyStaffStatic.subsidy
                      .realPerformance.money,
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
            >
              <div class="colItem">奖金</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.subsidyStaffStatic.petBonus
                    .realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.subsidyStaffStatic.petBonus
                      .realPerformance.money,
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[8].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.subsidyStaffStatic.royaltyProportion
                      .money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[8].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 核销业绩 -->
          <div
            class="tabBox"
            v-if="
              [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
            "
          >
            <div class="tabTit">
              <div class="colTit">
                核销业绩
                <!-- <span v-if="datas.staffStaticModel.verificationStaffStatic.nodeMoney.money>0">
									<span v-if="datas.staffStaticModel.verificationStaffStatic.nodeMoney.money>datas.staffStaticModel.verificationStaffStatic.indicatorPerformance.money">
										&lt; {{datas.staffStaticModel.verificationStaffStatic.nodeMoney.money}}
									</span>
									<span v-else>
										≥ {{datas.staffStaticModel.verificationStaffStatic.nodeMoney.money}}
									</span>
								</span>
								<span v-else>
									> {{datas.staffStaticModel.verificationStaffStatic.nodeMinMoney.money}}
								</span> -->
              </div>
              <div class="colTit">销售金额</div>
              <div class="colTit">提成比例</div>
              <div class="colTit">提成金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.verificationStaffStatic,
                    'verificationStaffStatic'
                  )
                "
              >
                查看
              </div>
              <el-tooltip effect="dark" placement="top-end">
                <div slot="content" v-if="flag==true">
                  会员余额、 疫苗驱虫、医疗服务消费业绩小于1万 提成3%，大于等于1万，提成5%
                </div>
                <div slot="content" v-if="flag==false">
                  会员余额消费业绩提成点为5%<br />疫苗驱虫核销业绩提成点为5%<br />医疗服务核销业绩提成点为5%
                </div>
                <div class="colTit rule">规则</div>
              </el-tooltip>
            </div>
            <div
              class="tabItem"
              v-if="
                [1, 2, 3, 4, 5].indexOf(datas.staffStaticModel.staffType) > -1
              "
            >
              <div class="colItem">商品余额核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.verificationStaffStatic
                    .goodsYuEPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.verificationStaffStatic
                      .goodsYuEPerformance.realPerformance.money,
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">病例余额核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.verificationStaffStatic
                    .caseYuEPerformance.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.verificationStaffStatic
                      .caseYuEPerformance.realPerformance.money,
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">疫苗驱虫核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.verificationStaffStatic
                    .medicalPackageRoyalty.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.verificationStaffStatic
                      .medicalPackageRoyalty.realPerformance.money,
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money
                  )
                }}
              </div>
            </div>
            <div
              class="tabItem"
              v-if="[1].indexOf(datas.staffStaticModel.staffType) > -1"
            >
              <div class="colItem">医疗服务核销</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.verificationStaffStatic
                    .medicalServiceRoyalty.realPerformance.money
                }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{
                  $public.cheng_1(
                    datas.staffStaticModel.verificationStaffStatic
                      .medicalServiceRoyalty.realPerformance.money,
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money
                  )
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[7].businessMoney }}
              </div>
              <div class="colItem">
                {{
                  $public.cheng(
                    datas.staffStaticModel.verificationStaffStatic
                      .royaltyProportion.money,
                    100
                  )
                }}%
              </div>
              <div class="colItem">
                {{ datas.royaltyChartList[7].royaltyMoney }}
              </div>
            </div>
          </div>
          <!-- 退款金额 -->
          <div class="tabBox">
            <div class="tabTit">
              <div class="colTit">
                退款金额
                <!-- <span v-if="datas.staffStaticModel.refundStaffStatic.nodeMoney.money>0">
									<span v-if="datas.staffStaticModel.refundStaffStatic.nodeMoney.money>datas.staffStaticModel.refundStaffStatic.indicatorPerformance.money">
										&lt; {{datas.staffStaticModel.refundStaffStatic.nodeMoney.money}}
									</span>
									<span v-else>
										≥ {{datas.staffStaticModel.refundStaffStatic.nodeMoney.money}}
									</span>
								</span>
								<span v-else>
									> {{datas.staffStaticModel.refundStaffStatic.nodeMinMoney.money}}
								</span> -->
              </div>
              <div class="colTit">退款金额</div>
              <div
                class="colTit see"
                @click="
                  toDetail(
                    datas.staffStaticModel.refundStaffStatic,
                    'refundStaffStatic'
                  )
                "
              >
                查看
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem">当月退款</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.refundStaffStatic
                    .refundServicePerformance.realPerformance.money
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem">往月退款</div>
              <div class="colItem">
                {{
                  datas.staffStaticModel.refundStaffStatic
                    .refundServiceLastPerformance.realPerformance.money
                }}
              </div>
            </div>
            <div class="tabItem">
              <div class="colItem" style="color: red">合计</div>
              <div class="colItem">
                {{ datas.royaltyChartList[9].businessMoney }}
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      dialogTableVisible: true,
      curStaffMsg: { staffName: "", staffId: "", position: "" },
      staffList: [],
      curDate: new Date(),

      state1: false,
      datas: {
        returnMoney: { all: 0, new: 0, old: 0 },
        orderCount: { current: 0, old: 0, rate: 0 },
        royaltyMoney: { current: 0, old: 0, rate: 0 },
        saleMoney: { current: 0, old: 0, rate: 0 },
        servicePeopleCount: { current: 0, old: 0, rate: 0 },
        rechargeMoney: { current: 0, old: 0, rate: 0 },
        performanceChartList: [],
        royaltyChartList: [],
        staffStaticModel: {},
      },
       flag:true,
      //  selectTime:'',
      myChart1: null,
      myChart2: null,
    };
  },
  computed: {
    shopId() {
      return this.$store.state.shopId;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  created() {
    this.getStaffList();
  },
  mounted() {
    this.myChart1 = echarts.init(document.getElementById("map1"));
    this.myChart2 = echarts.init(document.getElementById("map2"));

   
  },
  methods: {
  
    // seeRules(){
    // 	if(this.datas.staffStaticModel.staffType===5){
    // 		window.open('/pdf/5.pdf')
    // 	}else if(this.datas.staffStaticModel.staffType===3||this.datas.staffStaticModel.staffType===4){
    // 		window.open('/pdf/34.pdf')
    // 	}else if(this.datas.staffStaticModel.staffType===1||this.datas.staffStaticModel.staffType===2){
    // 		window.open('/pdf/12.pdf')
    // 	}
    // },
    toDetail(obj, type) {
      console.log(type,'type');
      sessionStorage.setItem("shuju_staffOrderList", JSON.stringify(obj));
      this.$router.push({
        path:
          "/staffshuju/staffshujuDetail?type=" +
          type +
          "&staffType=" +
          this.datas.staffStaticModel.staffType,
      });
    },
    changePicker(e) {
       let selecttime= this.$public.FTime(e.getTime(), "YYYY-MM-DD")
      this.flag=this.timepanduan(selecttime)
      this.getDatas();
      
     
     
    },
    // 员工
    changeStaff(val) {
      this.curStaffMsg = val;
      this.getDatas();
    },
   
    getStaffList() {
      this.$http
        .get(
          process.env.VUE_APP_Url_8015 +"/api/StaffStatic/GetShopStaffList",
          {}
        )
        .then((res) => {
          if (res.code === 0) {
          
              for (let i = 0; i < res.data.length; i++) {
                this.staffList = this.staffList.concat(
                  res.data[i].shopStaffList
                );
              }
            this.curStaffMsg = {};
            for (let i = 0; i < this.staffList.length; i++) {
              if (this.userInfo.staffId === this.staffList[i].staffId) {
                this.curStaffMsg = this.staffList[i];
              }
            }
            this.getDatas();
          }
        });
    },
    timepanduan(selecttime) {
      const time = '2023-07'
      const timeArr = time.split('-')
      const selectTimeArr = selecttime.split('-')
      return this.digui(timeArr, selectTimeArr)
    },
    digui(time, selecttime, index) {
      console.log(time[index||0],selecttime[index||0],"index");
      //对比两个数字返回1是大于 2是相等三是小于
      if (index > 1) return true
      if (selecttime[index || 0] > time[index || 0]) {
        return true
      } else if ((selecttime[index || 0]*1 ==time[index || 0]*1)) {
        return this.digui(time, selecttime, (index||0) + 1)
      } else {
        return false
      }
    },
    // 数据
    getDatas() {
      if (this.$public.isNull(this.curStaffMsg.staffId)) {
        this.curStaffMsg = this.staffList[0];
      }
      let params = {
        data: this.$public.FTime(this.curDate.getTime(), "YYYY-MM-DD"),
        staffId: this.curStaffMsg.staffId,
      };
      this.state1 = false;
      let loading = this.$loading();
      // process.env.VUE_APP_Url5+VUE_APP_Url_8015
      this.$http
        .get(
          process.env.VUE_APP_Url5+"api/StaffPerformanceDetail/staff/data",
          params
        )
        .then((res) => {
          this.$nextTick(() => {
            this.state1 = true;
            loading.close();
          });
          if (res.code === 0) {
            let d = res.data;
            this.datas = res.data;
            this.datas.royaltyMoney = {
              current: d.staffStaticModel.royaltyMoney.money,
              old: d.royaltyMoneyLastMon.money,
              // rate:
              //   d.royaltyMoneyLastMon.money === 0
              //     ? 0
              //     : this.$public.chu_1(
              //         this.$public.jian_1(
              //           d.staffStaticModel.royaltyMoney.money,
              //           d.royaltyMoneyLastMon.money
              //         ) * 100,
              //         d.royaltyMoneyLastMon.money
              //       ),
            };
            this.datas.saleMoney = {
              current: d.staffStaticModel.saleMoney.money,
              old: d.saleMoneyLastMon.money,
              // rate:
              //   d.saleMoneyLastMon.money === 0
              //     ? 0
              //     : this.$public.chu_1(
              //         this.$public.jian_1(
              //           d.staffStaticModel.saleMoney.money,
              //           d.saleMoneyLastMon.money
              //         ) * 100,
              //         d.saleMoneyLastMon.money
              //       ),
            };
            this.datas.rechargeMoney = {
              current:
                d.staffStaticModel.rechargeStaffStatic.rechargePerformance
                  .realPerformance.money,
              old: d.rechargeMoneyLastMon.money,
              // rate:
              //   d.rechargeMoneyLastMon.money === 0
              //     ? 0
              //     : this.$public.chu_1(
              //         this.$public.jian_1(
              //           d.staffStaticModel.rechargeStaffStatic
              //             .rechargePerformance.realPerformance.money,
              //           d.rechargeMoneyLastMon.money
              //         ) * 100,
              //         d.rechargeMoneyLastMon.money
              //       ),
            };
            this.datas.servicePeopleCount = {
              current: d.staffStaticModel.servicePeopleCount.money,
              old: d.servicePeopleCountLastMon.money,
              // rate:
              //   d.servicePeopleCountLastMon.money === 0
              //     ? 0
              //     : this.$public.chu_1(
              //         this.$public.jian_1(
              //           d.staffStaticModel.servicePeopleCount.money,
              //           d.servicePeopleCountLastMon.money
              //         ) * 100,
              //         d.servicePeopleCountLastMon.money
              //       ),
            };
            this.datas.orderCount = {
              current: d.staffStaticModel.orderCount.money,
              old: d.orderCountLastMon.money,
              // rate:
              //   d.orderCountLastMon.money === 0
              //     ? 0
              //     : this.$public.chu_1(
              //         this.$public.jian_1(
              //           d.staffStaticModel.orderCount.money,
              //           d.orderCountLastMon.money
              //         ) * 100,
              //         d.orderCountLastMon.money
              //       ),
            };
            this.datas.returnMoney = {
              all: d.staffStaticModel.refundMoney.money,
              new: d.staffStaticModel.refundMoneyMonth.money,
              old: d.staffStaticModel.refundMoneyLastMonth.money,
            };
            setTimeout(() => {
              this.drawLine();
              this.drawCircle();
            }, 500);
          }
        });
    },
    // getTotal(list){

    // },
    drawLine() {
      let list = this.datas.performanceChartList;
      let x = [];
      let y = [];
      for (let i = 0; i < list.length; i++) {
        let amount = 0;
        for (let key in list[i].oneDayData) {
          amount = this.$public.jia_1(amount, list[i].oneDayData[key].money);
        }
        list[i].amount = amount;
        x.push(list[i].date);
        y.push(list[i].amount);
      }
      this.myChart1.setOption({
        color: ["#467EFF"],
        xAxis: {
          type: "category",
          data: x,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: y,
            type: "line",
            smooth: true,
          },
        ],
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        tooltip: {
          trigger: "axis",
          formatter: (val) => {
            let staffType = this.datas.staffStaticModel.staffType;
            let str = "<div>" + val[0].name + "：" + val[0].value;
            for (let key in list[val[0].dataIndex].oneDayData) {
              if (staffType === 1) {
                if (
                  [
                    "sale",
                    "recharge",
                    "virtual",
                    "jiyang",
                    "subsidy",
                    "qita",
                    "heXiao",
                  ].indexOf(key) > -1
                ) {
                  str =
                    str +
                    "<div style='padding-left:51px;'>" +
                    list[val[0].dataIndex].oneDayData[key].moneyName +
                    "：" +
                    list[val[0].dataIndex].oneDayData[key].money +
                    "</div>";
                }
              } else if (staffType === 2) {
                if (
                  [
                    "sale",
                    "recharge",
                    "virtual",
                    "jiyang",
                    "follow",
                    "qita",
                    "heXiao",
                  ].indexOf(key) > -1
                ) {
                  str =
                    str +
                    "<div style='padding-left:51px;'>" +
                    list[val[0].dataIndex].oneDayData[key].moneyName +
                    "：" +
                    list[val[0].dataIndex].oneDayData[key].money +
                    "</div>";
                }
              } else if (staffType === 3) {
                if (
                  [
                    "sale",
                    "xiMei",
                    "meiRong",
                    "recharge",
                    "virtual",
                    "jiyang",
                    "heXiao",
                  ].indexOf(key) > -1
                ) {
                  str =
                    str +
                    "<div style='padding-left:51px;'>" +
                    list[val[0].dataIndex].oneDayData[key].moneyName +
                    "：" +
                    list[val[0].dataIndex].oneDayData[key].money +
                    "</div>";
                }
              } else if (staffType === 4) {
                if (
                  [
                    "sale",
                    "xiMei",
                    "meiRong",
                    "recharge",
                    "virtual",
                    "jiyang",
                    "subsidy",
                    "heXiao",
                  ].indexOf(key) > -1
                ) {
                  str =
                    str +
                    "<div style='padding-left:51px;'>" +
                    list[val[0].dataIndex].oneDayData[key].moneyName +
                    "：" +
                    list[val[0].dataIndex].oneDayData[key].money +
                    "</div>";
                }
              } else if (staffType === 5) {
                if (
                  ["sale", "recharge", "virtual", "jiyang", "heXiao"].indexOf(
                    key
                  ) > -1
                ) {
                  str =
                    str +
                    "<div style='padding-left:51px;'>" +
                    list[val[0].dataIndex].oneDayData[key].moneyName +
                    "：" +
                    list[val[0].dataIndex].oneDayData[key].money +
                    "</div>";
                }
              }
            }
            str = str + "</div>";
            return str;
          },
        },
      });
    },
    drawCircle() {
      let staffType = this.datas.staffStaticModel.staffType;
      let list = this.datas.royaltyChartList;
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (staffType === 1) {
          if (
            [
              "流水",
              "充值",
              "综合",
              "寄养",
              "补助",
              "其它",
              "核销业绩",
            ].indexOf(list[i].name) > -1
          ) {
            arr.push({ value: list[i].royaltyMoney, name: list[i].name, i: i });
          }
        } else if (staffType === 2) {
          if (
            [
              "流水",
              "充值",
              "综合",
              "寄养",
              "跟诊",
              "其它",
              "核销业绩",
            ].indexOf(list[i].name) > -1
          ) {
            arr.push({ value: list[i].royaltyMoney, name: list[i].name, i: i });
          }
        } else if (staffType === 3) {
          if (
            [
              "流水",
              "洗澡",
              "美容",
              "充值",
              "综合",
              "寄养",
              "核销业绩",
            ].indexOf(list[i].name) > -1
          ) {
            arr.push({ value: list[i].royaltyMoney, name: list[i].name, i: i });
          }
        } else if (staffType === 4) {
          if (
            [
              "流水",
              "洗澡",
              "美容",
              "充值",
              "综合",
              "寄养",
              "其它",
              "核销业绩",
            ].indexOf(list[i].name) > -1
          ) {
            arr.push({ value: list[i].royaltyMoney, name: list[i].name, i: i });
          }
        } else if (staffType === 5) {
          if (
            ["流水", "充值", "综合", "寄养", "核销业绩"].indexOf(list[i].name) >
            -1
          ) {
            arr.push({ value: list[i].royaltyMoney, name: list[i].name, i: i });
          }
        }
      }
      this.myChart2.setOption({
        color: [
          "#F5882A",
          "#58A2F7",
          "#FBCB63",
          "#F76260",
          "#8167F5",
          "#F5EC67",
          "#28D3DB",
          "#96D9FF",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: "30",
          top: "middle",
          textStyle: {
            fontSize: "16",
            color: "#8C8C8C",
            lineHeight: "30",
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["40%", "80%"],
            center: [130, 130],
            label: {
              position: "inner",
              fontSize: 14,
              formatter: (val) => {
                return val.percent + "%";
              },
            },
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            tooltip: {
              formatter: (val) => {
                console.log(val);
                return (
                  "<div>" +
                  val.name +
                  "提成：" +
                  val.value +
                  "(" +
                  val.percent +
                  "%)" +
                  "<div >" +
                  "销售金额：" +
                  list[val.data.i].businessMoney +
                  "</div>" +
                  "<div >" +
                  "订单数量：" +
                  list[val.data.i].orderCount +
                  "</div>" +
                  "</div>"
                );
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.page {
  width: 100%;
  height: 100%;
  .mainColor {
    color: $mainColor;
  }
  .nucleus {
    background-color: #fff;
    padding: 10px;
    padding-bottom: 20px;
    .nucleustit {
      display: flex;
      justify-content: space-between;
      height: 40px;
      border-bottom: 1px solid #f2f2f2;
      box-sizing: border-box;
      .suntit {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        margin-top: 8px;
        margin-left: 6px;
        .position {
          color: #666666;
          font-size: 12px;
          font-weight: 100;
        }
      }
    }
    .nucleuscon {
      margin-top: 10px;
      display: flex;
      .nucleusitem {
        border-right: 1px solid #ddd;
        width: 20%;
        display: flex;
        justify-content: center;
        // display: inline-block;
        box-sizing: border-box;
        margin: auto;
        margin-top: 20px;
        &:last-child {
          border: none;
        }
        .content {
          max-width: 180px;
          margin: auto;
        }
        .currentit {
          color: #666666;
          font-size: 14px;
        }
        .data {
          margin: 10px 0;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
        .compare {
          color: #666666;
          font-size: 12px;
        }
      }
    }
  }
  .saledatacontent {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    height: calc(100% - 191px);
    .L {
      width: 474px;
      flex-shrink: 0;
      margin-right: 10px;
      .mapBox {
        background-color: #fff;
        border-radius: 4px;
        padding: 12px;
        box-sizing: border-box;
        .mapTitle {
          color: #333333;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
    .R {
      width: 100%;
      .rulesLine {
        display: flex;
        justify-content: space-between;
        height: 52px;
        padding: 10px;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 4px;
        margin-bottom: 10px;
        .money {
          color: #666666;
          font-size: 14px;
          line-height: 32px;
        }
        .rules {
          color: $mainColor;
          font-size: 12px;
          line-height: 32px;
          cursor: pointer;
        }
      }
      .scoll {
        height: calc(100% - 62px);
        overflow: auto;
        .tabBox {
          padding-bottom: 10px;
          background-color: #fff;
          .tabTit {
            background-color: $tableTitBg;
            display: flex;
            justify-content: space-between;
            height: 44px;
            color: #333333;
            position: relative;
            .colTit {
              line-height: 44px;
              padding: 0 20px;
              width: 100%;
              font-size: 14px;
            }
            .see {
              position: absolute;
              right: 38px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
            .rule {
              position: absolute;
              right: 0px;
              padding-right: 10px;
              color: $mainColor;
              flex-grow: 0;
              cursor: pointer;
              width: 28px;
              padding: 0 8px;
            }
          }
          .tabItem {
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            height: 44px;
            border-bottom: 1px solid #f2f2f2;
            color: #333333;
            .colItem {
              line-height: 44px;
              padding: 0 20px;
              width: 100%;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
